"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _locationPrompt = _interopRequireDefault(require("./location-prompt.css"));
var _commonCta = require("@mmc/common-cta");
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var promptStates = {
  open_by_system: 'open_by_system',
  open: 'open',
  submitted: 'submitted',
  dismissed: 'dismissed'
};
var autoCloseDuration = 30000; /* in milliseconds */
var messageDisplayDuration = 2000; /* in milliseconds */

var LocationPrompt = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _clsx, _clsx2;
  var className = _ref.className,
    market = _ref.market,
    language = _ref.language,
    theme = _ref.theme,
    data = _ref.data,
    onDismissed = _ref.onDismissed;
  var _useState = (0, _react.useState)(promptStates.dismissed),
    promptState = _useState[0],
    setPromptState = _useState[1];
  var _useState2 = (0, _react.useState)(''),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    autocloseTimer = _useState3[0],
    setAutocloseTimer = _useState3[1];
  var promptStateRef = (0, _react.useRef)('');
  var dismissTimerRef = (0, _react.useRef)('');
  var locationPrompt = data.locationPrompt;
  var confirmLocation = function confirmLocation() {
    _closePrompt(promptStates.submitted, messageDisplayDuration);
  };
  var _closePrompt = function closePrompt(promptState, delay) {
    if (promptState) {
      setPromptState(promptState);
    }
    localStorage.setItem('locationPrompt', 'off');
    if (!dismissTimerRef.current) {
      var dismissTimerObj = setTimeout(function () {
        document.body.setAttribute('data-location-prompt', 'close');
        setTimeout(function () {
          window.dispatchEvent(new CustomEvent('scroll'));
          setPromptState(promptStates.dismissed);
        }, 500);
        resetDismissTimer();
      }, delay);
      dismissTimerRef.current = dismissTimerObj;
    }
  };
  var resetDismissTimer = function resetDismissTimer() {
    clearTimeout(dismissTimerRef.current);
    dismissTimerRef.current = null;
  };
  var _openPrompt = function openPrompt(promptState) {
    document.body.setAttribute('data-location-prompt', 'open');
    localStorage.setItem('locationPrompt', 'off');
    if (promptState) {
      setPromptState(promptState);
    }
  };
  (0, _react.useEffect)(function () {
    if (promptState === promptStates.open_by_system) {
      startAutoCloseTimer();
    } else if (promptState === promptStates.submitted) {
      _closePrompt('', messageDisplayDuration);
    }
    promptStateRef.current = promptState;
  }, [promptState]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      closePrompt: function closePrompt(state, delay) {
        _closePrompt(state, delay);
      },
      openPrompt: function openPrompt(state) {
        _openPrompt(state);
      },
      promptState: promptState,
      promptStates: promptStates
    };
  });
  (0, _react.useEffect)(function () {
    _commonLibs.EventEmitter.subscribe('locationChangeEvent', function (data) {
      var currentCachedLocation = (0, _commonSetLocation.getCachedLocation)();
      if ((currentCachedLocation == null ? void 0 : currentCachedLocation.searchValue) !== (data == null ? void 0 : data.searchValue)) {
        handleLocationChange(data);
        (0, _commonSetLocation.setCachedLocation)(data);
      }
    });
    var promptStatus = localStorage.getItem('locationPrompt');
    if (promptStatus !== 'off') {
      var oneTrustCheckInterval = setInterval(function () {
        var consentChanged = localStorage.getItem('consentChanged');
        if (consentChanged === 'true') {
          _openPrompt(promptStates.open_by_system);
          clearInterval(oneTrustCheckInterval);
        }
      }, 2000);
    }
  }, []);
  var handleLocationChange = function handleLocationChange(data) {
    setLocation(data);
    _openPrompt(promptStates.submitted);
    window.dispatchEvent(new CustomEvent('scroll'));
  };
  var startAutoCloseTimer = function startAutoCloseTimer() {
    if (promptState === promptStates.open_by_system) {
      var timerObj = setTimeout(function () {
        _closePrompt('', messageDisplayDuration);
        setAutocloseTimer(null);
        clearTimeout(autocloseTimer);
        if (promptStateRef.current === promptStates.open_by_system) {
          _commonLibs.EventEmitter.dispatch('locationPromptAutoClose');
        }
      }, autoCloseDuration);
      setAutocloseTimer(timerObj);
    }
  };
  var resetAutoCloseTimer = function resetAutoCloseTimer() {
    clearTimeout(autocloseTimer);
    setAutocloseTimer(null);
  };
  var dismiss = function dismiss() {
    _closePrompt(promptStates.dismissed, 0);
    if (onDismissed) {
      onDismissed();
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])((_clsx = {}, _clsx[_locationPrompt["default"].locationPrompt] = true, _clsx[theme.light] = true, _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])((_clsx2 = {}, _clsx2[_locationPrompt["default"].formWrapper] = true, _clsx2[_locationPrompt["default"].visible] = promptState === promptStates.open || promptState === promptStates.open_by_system, _clsx2)),
    onMouseLeave: function onMouseLeave() {
      return startAutoCloseTimer();
    },
    onMouseEnter: function onMouseEnter() {
      return resetAutoCloseTimer();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _locationPrompt["default"].formRow
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(theme['col-md-9'], theme['col-sm-9'], theme['col-xs-12'])
  }, /*#__PURE__*/_react["default"].createElement(_commonSetLocation.CommonSetLocationForm, {
    className: _locationPrompt["default"].commonSetLocationWrapper,
    data: locationPrompt,
    dark: false,
    padding: false,
    theme: theme,
    globalLocation: location,
    onLocationSelected: setLocation
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(theme['col-md-3'], theme['col-sm-3'], theme['col-xs-12'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _locationPrompt["default"].ctaWrapper
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      label: locationPrompt.ctaLabel,
      priority: 'medium'
    },
    disabled: !(location && location.searchValue),
    spanClasses: (0, _clsx3["default"])(_locationPrompt["default"].ctaSpan),
    classes: [_locationPrompt["default"].lowIconCta],
    clickEvent: confirmLocation
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _locationPrompt["default"].closeBtn,
    onClick: function onClick() {
      return dismiss();
    }
  }))))), promptState === promptStates.submitted && /*#__PURE__*/_react["default"].createElement("p", {
    className: _locationPrompt["default"].confirmMsg
  }, locationPrompt.locationSelectedMessage, ' ', /*#__PURE__*/_react["default"].createElement("span", null, location == null ? void 0 : location.searchValue)));
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
LocationPrompt.resourceType = function () {
  return 'LocationPrompt_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps, null, null, {
  withRef: true
})(LocationPrompt);
exports["default"] = _default;